import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const STORAGE_KEY = "makerizk_lang_v1";

const dict = {
    fr: {
        // Nav
        "nav.home": "Accueil",
        "nav.collection": "Collection",
        "nav.tshirts": "T-Shirts",
        "nav.caps": "Casquettes",
        "nav.cart": "Panier",
        "nav.wishlist": "Favoris",
        "nav.search": "Rechercher",
        "nav.search_placeholder": "Rechercher un produit...",
        "nav.open_menu": "Ouvrir le menu",
        "nav.close": "Fermer",

        // Hero
        "hero.eyebrow": "Nouvelle Collection · Hiver 2026",
        "hero.title_1": "Fait pour",
        "hero.title_2": "la rue.",
        "hero.title_3": "Pas pour suivre.",
        "hero.cta_collection": "Découvrir la collection",
        "hero.cta_caps": "Voir les casquettes",

        // Sections
        "section.new_eyebrow": "Fraîchement débarqués",
        "section.new_title": "Nouveautés",
        "section.best_eyebrow": "Vos favoris",
        "section.best_title": "Meilleures ventes",
        "section.view_all": "Voir tout",
        "section.tshirts_sub": "Essentiels & oversize",
        "section.caps_sub": "Snapback, dad, trucker",
        "section.explore": "Explorer",

        // Marquee
        "marquee.delivery": "Livraison partout au Maroc",
        "marquee.cod": "Paiement à la livraison",
        "marquee.returns": "Retour sous 7 jours",
        "marquee.limited": "Édition limitée",

        // Trust
        "trust.delivery_title": "Livraison Maroc",
        "trust.delivery_desc": "Partout au Maroc en 24-72h. Suivi par SMS.",
        "trust.cod_title": "Paiement à la livraison",
        "trust.cod_desc": "Payez cash en recevant votre commande.",
        "trust.returns_title": "Retour 7 jours",
        "trust.returns_desc": "Un souci ? Échange ou remboursement sous 7 jours.",

        // Product
        "product.tshirt": "T-Shirt",
        "product.cap": "Casquette",
        "product.size": "Taille",
        "product.selected": "Sélectionnée",
        "product.add_to_cart": "Ajouter au panier",
        "product.select_size": "Sélectionne une taille",
        "product.added": "Ajouté au panier",
        "product.in_stock": "En stock — expédition sous 24h",
        "product.delivery": "Livraison partout au Maroc (24-72h)",
        "product.cod": "Paiement à la livraison (Cash on Delivery)",
        "product.returns": "Retour ou échange sous 7 jours",
        "product.not_found": "Produit introuvable",
        "product.back_collection": "Retour à la collection",

        // Wishlist
        "wishlist.title": "Favoris",
        "wishlist.empty": "Aucun favori pour l'instant",
        "wishlist.empty_desc": "Ajoute tes pièces préférées en cliquant sur le cœur.",
        "wishlist.explore": "Explorer la collection",
        "wishlist.add": "Ajouter aux favoris",
        "wishlist.remove": "Retirer des favoris",
        "wishlist.items": "pièce(s) sauvegardée(s)",

        // Cart
        "cart.title": "Panier",
        "cart.empty": "Ton panier est vide",
        "cart.empty_desc": "Explore la collection pour trouver ta pièce.",
        "cart.discover": "Découvrir",
        "cart.subtotal": "Sous-total",
        "cart.shipping": "Livraison",
        "cart.total": "Total",
        "cart.checkout": "Passer commande",
        "cart.cod_available": "Paiement à la livraison disponible",
        "cart.decrease": "Diminuer",
        "cart.increase": "Augmenter",
        "cart.remove": "Supprimer",

        // Checkout
        "checkout.continue_shop": "Continuer les achats",
        "checkout.title": "Commande",
        "checkout.section_contact": "01 · Contact",
        "checkout.section_shipping": "02 · Livraison",
        "checkout.section_payment": "03 · Paiement",
        "checkout.name": "Nom complet",
        "checkout.name_placeholder": "Ex : Youssef El Amrani",
        "checkout.phone": "Téléphone",
        "checkout.phone_placeholder": "06 12 34 56 78",
        "checkout.email": "Email (optionnel)",
        "checkout.email_placeholder": "toi@exemple.com",
        "checkout.email_hint": "Reçois ton reçu de commande par email.",
        "checkout.address": "Adresse complète",
        "checkout.address_placeholder": "Rue, quartier, appartement...",
        "checkout.city": "Ville",
        "checkout.city_placeholder": "Sélectionner une ville",
        "checkout.notes": "Note (optionnel)",
        "checkout.notes_placeholder": "Précisions livraison, préférences...",
        "checkout.cod_title": "Paiement à la livraison",
        "checkout.cod_desc":
            "Vous payez en espèces (MAD) au livreur à la réception de votre colis. Aucun paiement en ligne requis.",
        "checkout.confirm": "Confirmer la commande",
        "checkout.summary": "Récapitulatif",
        "checkout.qty": "Qté",
        "checkout.size": "Taille",
        "checkout.empty_title": "Panier vide",
        "checkout.empty_desc": "Ajoute des produits avant de passer commande.",
        "checkout.see_collection": "Voir la collection",
        "checkout.err_fields": "Remplis tous les champs obligatoires",
        "checkout.err_phone": "Numéro de téléphone invalide",
        "checkout.err_email": "Adresse email invalide",
        "checkout.err_generic": "Erreur lors de la commande. Réessaie.",
        "checkout.submitting": "Envoi en cours...",

        // Order confirmation
        "order.thank_you": "Merci pour ta commande",
        "order.title": "Commande confirmée",
        "order.contact_soon_1": "Un de nos agents te contactera bientôt au",
        "order.contact_soon_2": "pour confirmer la livraison.",
        "order.number": "Numéro de commande",
        "order.delivery_to": "Livraison à",
        "order.total_pay": "Total à payer",
        "order.cod_title": "Paiement à la livraison",
        "order.cod_desc": "Prépare {amount} en espèces à remettre au livreur.",
        "order.continue_shop": "Continuer les achats",
        "order.contact_us": "Nous contacter",
        "order.not_found": "Commande introuvable",
        "order.tracking_title": "Suivre mon colis",
        "order.tracking_desc": "Suis l'acheminement de ta commande en temps réel.",

        // Footer
        "footer.streetwear_morocco": "Streetwear · Maroc",
        "footer.tagline_1": "Wear it,",
        "footer.tagline_2": "own it.",
        "footer.brand_desc":
            "Make Rizk crée des pièces streetwear pensées pour la rue marocaine. Simple, brut, essentiel.",
        "footer.shop": "Boutique",
        "footer.all_products": "Tous les produits",
        "footer.info": "Infos",
        "footer.cod": "Paiement à la livraison",
        "footer.delivery": "Livraison 24-72h",
        "footer.returns_7": "Retours sous 7 jours",
        "footer.instagram": "Instagram",
        "footer.rights": "Tous droits réservés.",
        "footer.location": "Casablanca · Maroc",

        // Catalog
        "catalog.title_all": "Collection",
        "catalog.title_tshirt": "T-Shirts",
        "catalog.title_cap": "Casquettes",
        "catalog.title_search": "Résultats de recherche",
        "catalog.filter_all": "Tout",
        "catalog.filter_tshirt": "T-Shirts",
        "catalog.filter_cap": "Casquettes",
        "catalog.pieces_available": "pièce(s) disponible(s)",
        "catalog.no_products": "Aucun produit disponible.",
        "catalog.no_search_results": "Aucun résultat pour",
        "catalog.eyebrow": "Make Rizk",
        "catalog.results_for": "Résultats pour",

        // Promo popup
        "promo.eyebrow": "Offre exclusive",
        "promo.title_1": "−10%",
        "promo.title_2": "sur ta wishlist.",
        "promo.desc":
            "On te réserve une remise sur ta prochaine commande. Utilise ce code au checkout et repars avec tes coups de cœur.",
        "promo.your_code": "Ton code",
        "promo.copy": "Copier",
        "promo.copied": "Copié !",
        "promo.cta_wishlist": "Voir ma wishlist",
        "promo.cta_cart": "Finaliser mon panier",
        "promo.dismiss": "Non merci",
        "promo.expires": "Valable pendant 24h",

        // Checkout promo
        "checkout.promo_label": "Code promo",
        "checkout.promo_placeholder": "Ex: RIZK10",
        "checkout.promo_apply": "Appliquer",
        "checkout.promo_applied": "Code appliqué",
        "checkout.promo_invalid": "Code invalide",
        "checkout.promo_remove": "Retirer",
        "checkout.discount": "Remise",

        // WhatsApp
        "whatsapp.support_label": "Une question ?",
        "whatsapp.support_aria": "Contacter le support Make Rizk sur WhatsApp",
        "whatsapp.support_msg":
            "Bonjour Make Rizk, j'aimerais avoir plus d'informations sur vos produits.",
        "whatsapp.send_order": "Envoyer la commande sur WhatsApp",
        "whatsapp.send_order_desc":
            "Confirme ta commande directement avec nous sur WhatsApp pour un traitement plus rapide.",
    },
    ar: {
        // Nav
        "nav.home": "الرئيسية",
        "nav.collection": "المجموعة",
        "nav.tshirts": "تيشرتات",
        "nav.caps": "قبعات",
        "nav.cart": "السلة",
        "nav.wishlist": "المفضلة",
        "nav.search": "بحث",
        "nav.search_placeholder": "ابحث عن منتج...",
        "nav.open_menu": "فتح القائمة",
        "nav.close": "إغلاق",

        // Hero
        "hero.eyebrow": "المجموعة الجديدة · شتاء 2026",
        "hero.title_1": "مصنوع",
        "hero.title_2": "للشارع.",
        "hero.title_3": "لا لتقليد أحد.",
        "hero.cta_collection": "اكتشف المجموعة",
        "hero.cta_caps": "شاهد القبعات",

        // Sections
        "section.new_eyebrow": "وصل حديثاً",
        "section.new_title": "الجديد",
        "section.best_eyebrow": "الأكثر طلباً",
        "section.best_title": "الأكثر مبيعاً",
        "section.view_all": "عرض الكل",
        "section.tshirts_sub": "أساسيات وقصّات واسعة",
        "section.caps_sub": "سناب باك، داد كاب، تراكر",
        "section.explore": "استكشاف",

        // Marquee
        "marquee.delivery": "توصيل في جميع أنحاء المغرب",
        "marquee.cod": "الدفع عند الاستلام",
        "marquee.returns": "إرجاع خلال 7 أيام",
        "marquee.limited": "إصدار محدود",

        // Trust
        "trust.delivery_title": "التوصيل في المغرب",
        "trust.delivery_desc": "في جميع المدن خلال 24 إلى 72 ساعة، مع تتبع عبر الرسائل القصيرة.",
        "trust.cod_title": "الدفع عند الاستلام",
        "trust.cod_desc": "ادفع نقداً عند استلام طلبك، بدون أي دفع مسبق.",
        "trust.returns_title": "إرجاع خلال 7 أيام",
        "trust.returns_desc": "مشكلة في المقاس؟ الاستبدال أو الاسترجاع مضمون خلال 7 أيام.",

        // Product
        "product.tshirt": "تيشرت",
        "product.cap": "قبعة",
        "product.size": "المقاس",
        "product.selected": "المقاس المختار",
        "product.add_to_cart": "أضف إلى السلة",
        "product.select_size": "اختر مقاساً من فضلك",
        "product.added": "تمت الإضافة إلى السلة",
        "product.in_stock": "متوفر في المخزون · الشحن خلال 24 ساعة",
        "product.delivery": "التوصيل في جميع أنحاء المغرب (24 إلى 72 ساعة)",
        "product.cod": "الدفع عند الاستلام نقداً",
        "product.returns": "الاستبدال أو الاسترجاع خلال 7 أيام",
        "product.not_found": "المنتج غير موجود",
        "product.back_collection": "العودة إلى المجموعة",

        // Wishlist
        "wishlist.title": "المفضلة",
        "wishlist.empty": "لا توجد قطع في مفضلتك بعد",
        "wishlist.empty_desc": "أضف قطعك المفضلة بالنقر على أيقونة القلب.",
        "wishlist.explore": "استكشف المجموعة",
        "wishlist.add": "أضف إلى المفضلة",
        "wishlist.remove": "أزل من المفضلة",
        "wishlist.items": "قطعة محفوظة",

        // Cart
        "cart.title": "السلة",
        "cart.empty": "سلتك فارغة",
        "cart.empty_desc": "تصفح المجموعة واختر قطعتك.",
        "cart.discover": "اكتشف الآن",
        "cart.subtotal": "المجموع الفرعي",
        "cart.shipping": "التوصيل",
        "cart.total": "المجموع الكلي",
        "cart.checkout": "إتمام الطلب",
        "cart.cod_available": "الدفع عند الاستلام متاح",
        "cart.decrease": "تقليل الكمية",
        "cart.increase": "زيادة الكمية",
        "cart.remove": "حذف",

        // Checkout
        "checkout.continue_shop": "متابعة التسوق",
        "checkout.title": "إتمام الطلب",
        "checkout.section_contact": "01 · معلومات التواصل",
        "checkout.section_shipping": "02 · عنوان التوصيل",
        "checkout.section_payment": "03 · طريقة الدفع",
        "checkout.name": "الاسم الكامل",
        "checkout.name_placeholder": "مثال: يوسف العمراني",
        "checkout.phone": "رقم الهاتف",
        "checkout.phone_placeholder": "06 12 34 56 78",
        "checkout.email": "البريد الإلكتروني (اختياري)",
        "checkout.email_placeholder": "you@example.com",
        "checkout.email_hint": "احصل على إيصال الطلب عبر البريد الإلكتروني.",
        "checkout.address": "العنوان الكامل",
        "checkout.address_placeholder": "الشارع، الحي، رقم الشقة...",
        "checkout.city": "المدينة",
        "checkout.city_placeholder": "اختر مدينتك",
        "checkout.notes": "ملاحظة (اختياري)",
        "checkout.notes_placeholder": "تفاصيل إضافية للتوصيل...",
        "checkout.cod_title": "الدفع عند الاستلام",
        "checkout.cod_desc":
            "ستدفع نقداً بالدرهم للموصل لحظة استلام طلبك. لا حاجة لأي دفع إلكتروني.",
        "checkout.confirm": "تأكيد الطلب",
        "checkout.summary": "ملخص الطلب",
        "checkout.qty": "الكمية",
        "checkout.size": "المقاس",
        "checkout.empty_title": "السلة فارغة",
        "checkout.empty_desc": "أضف منتجات قبل تأكيد الطلب.",
        "checkout.see_collection": "عرض المجموعة",
        "checkout.err_fields": "الرجاء ملء جميع الحقول المطلوبة",
        "checkout.err_phone": "رقم الهاتف غير صالح",
        "checkout.err_email": "البريد الإلكتروني غير صالح",
        "checkout.err_generic": "حدث خطأ أثناء الطلب، حاول مرة أخرى.",
        "checkout.submitting": "جارٍ الإرسال...",

        // Order confirmation
        "order.thank_you": "شكراً لطلبك",
        "order.title": "تم تأكيد طلبك",
        "order.contact_soon_1": "سيتصل بك أحد موظفينا قريباً على الرقم",
        "order.contact_soon_2": "لتأكيد موعد التوصيل.",
        "order.number": "رقم الطلب",
        "order.delivery_to": "التوصيل إلى",
        "order.total_pay": "المبلغ الإجمالي للدفع",
        "order.cod_title": "الدفع عند الاستلام",
        "order.cod_desc": "جهّز مبلغ {amount} نقداً لتسليمه للموصل.",
        "order.continue_shop": "متابعة التسوق",
        "order.contact_us": "تواصل معنا",
        "order.not_found": "الطلب غير موجود",
        "order.tracking_title": "تتبع طلبي",
        "order.tracking_desc": "تابع مسار طلبك في الوقت الحقيقي.",

        // Footer
        "footer.streetwear_morocco": "ستريتوير · المغرب",
        "footer.tagline_1": "البسها،",
        "footer.tagline_2": "امتلكها.",
        "footer.brand_desc":
            "تصنع Make Rizk قطع ستريتوير مستوحاة من الشارع المغربي. تصميم بسيط، خام، وأساسي.",
        "footer.shop": "المتجر",
        "footer.all_products": "كل المنتجات",
        "footer.info": "معلومات مفيدة",
        "footer.cod": "الدفع عند الاستلام",
        "footer.delivery": "التوصيل خلال 24-72 ساعة",
        "footer.returns_7": "الإرجاع خلال 7 أيام",
        "footer.instagram": "إنستغرام",
        "footer.rights": "جميع الحقوق محفوظة.",
        "footer.location": "الدار البيضاء · المغرب",

        // Catalog
        "catalog.title_all": "المجموعة",
        "catalog.title_tshirt": "التيشرتات",
        "catalog.title_cap": "القبعات",
        "catalog.title_search": "نتائج البحث",
        "catalog.filter_all": "الكل",
        "catalog.filter_tshirt": "تيشرتات",
        "catalog.filter_cap": "قبعات",
        "catalog.pieces_available": "قطعة متوفرة",
        "catalog.no_products": "لا توجد منتجات متاحة حالياً.",
        "catalog.no_search_results": "لا نتائج للبحث عن",
        "catalog.eyebrow": "Make Rizk",
        "catalog.results_for": "نتائج البحث عن",

        // Promo popup
        "promo.eyebrow": "عرض حصري",
        "promo.title_1": "−10٪",
        "promo.title_2": "على مفضلتك.",
        "promo.desc":
            "احصل على خصم على طلبك القادم. استخدم هذا الرمز عند إتمام الطلب واحصل على قطعك المفضلة.",
        "promo.your_code": "رمز الخصم",
        "promo.copy": "نسخ",
        "promo.copied": "تم النسخ!",
        "promo.cta_wishlist": "عرض المفضلة",
        "promo.cta_cart": "إتمام الطلب",
        "promo.dismiss": "لا شكراً",
        "promo.expires": "صالح لمدة 24 ساعة",

        // Checkout promo
        "checkout.promo_label": "رمز الخصم",
        "checkout.promo_placeholder": "مثال: RIZK10",
        "checkout.promo_apply": "تطبيق",
        "checkout.promo_applied": "تم تطبيق الرمز",
        "checkout.promo_invalid": "الرمز غير صالح",
        "checkout.promo_remove": "إزالة",
        "checkout.discount": "الخصم",

        // WhatsApp
        "whatsapp.support_label": "لديك سؤال؟",
        "whatsapp.support_aria": "تواصل مع Make Rizk عبر واتساب",
        "whatsapp.support_msg":
            "مرحباً Make Rizk، أود الحصول على مزيد من المعلومات حول منتجاتكم.",
        "whatsapp.send_order": "إرسال الطلب عبر واتساب",
        "whatsapp.send_order_desc":
            "أكّد طلبك مباشرة معنا على واتساب لمعالجة أسرع.",
    },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved === "ar" ? "ar" : "fr";
        } catch (_) {
            return "fr";
        }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, lang);
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        document.documentElement.style.setProperty(
            "--body-font",
            lang === "ar"
                ? '"Noto Sans Arabic", "Manrope", sans-serif'
                : '"Manrope", sans-serif'
        );
    }, [lang]);

    const t = useCallback(
        (key, params = {}) => {
            let value = dict[lang]?.[key] ?? dict.fr[key] ?? key;
            Object.entries(params).forEach(([k, v]) => {
                value = value.replace(`{${k}}`, v);
            });
            return value;
        },
        [lang]
    );

    const toggleLang = useCallback(() => {
        setLang((l) => (l === "fr" ? "ar" : "fr"));
    }, []);

    const value = useMemo(
        () => ({ lang, setLang, toggleLang, t, isRtl: lang === "ar" }),
        [lang, t, toggleLang]
    );

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be used within I18nProvider");
    return ctx;
}
